export default __webpack_public_path__ + "static/media/pic3.8d523c7e.jpg";